import Chip from '@mui/material/Chip';
import { Trans } from '@lingui/react/macro';

export const IncompleteDataLabel = () => {
  return (
    <Chip color="warning" size="small" variant="outlined" label={<Trans>Incomplete Data</Trans>} />
  );
};
